// EGN mobilmenu: skift mellem forsiden af menuen og en kategori. Temaets <mobile-nav> åbner/lukker selve skuffen.
// Lytteren sidder på document (delegering), fordi temaet kan hydrere/erstatte <mobile-nav> efter indlæsning.
(() => {
  const menu = () => document.querySelector('#MobileNav .egn-mm')
  const host = () => document.getElementById('MobileNav')
  let lastOpener = null

  const show = (id, opener) => {
    const root = menu()
    if (!root) return
    root.querySelectorAll('[data-egn-mm-panel]').forEach((p) => { p.hidden = p.dataset.egnMmPanel !== id })
    root.querySelectorAll('[data-egn-mm-open]').forEach((b) => b.setAttribute('aria-expanded', b.dataset.egnMmOpen === id ? 'true' : 'false'))
    const h = host()
    if (h) h.scrollTop = 0
    if (id === 'root') {
      opener && opener.focus({ preventScroll: true })
    } else {
      const t = root.querySelector(`[data-egn-mm-panel="${id}"] .egn-mm__h2`)
      t && t.focus({ preventScroll: true })
    }
  }

  // Skuffen ligger fast fra headerens bund til skærmens bund (ellers skjules det nederste indhold).
  const fit = () => {
    const h = host()
    if (!h) return
    h.classList.add('egn-mm-host')
    const header = document.getElementById('SiteHeader')
    const top = header ? Math.max(Math.round(header.getBoundingClientRect().bottom), 0) : 0
    h.style.setProperty('--egn-mm-top', top + 'px')
  }

  document.addEventListener('click', (e) => {
    if (!e.target.closest || !e.target.closest('#MobileNav .egn-mm')) return
    const open = e.target.closest('[data-egn-mm-open]')
    if (open) {
      e.stopPropagation()
      lastOpener = open
      show(open.dataset.egnMmOpen)
      return
    }
    if (e.target.closest('[data-egn-mm-back]')) {
      e.stopPropagation()
      show('root', lastOpener)
    }
  }, true)

  document.addEventListener('MobileNav:open', () => requestAnimationFrame(fit))
  window.addEventListener('resize', () => { const h = host(); if (h && h.classList.contains('is-active')) fit() })
  window.addEventListener('scroll', () => { const h = host(); if (h && h.classList.contains('is-active')) fit() }, { passive: true })
  // Næste gang skuffen åbnes, starter man på forsiden af menuen.
  document.addEventListener('MobileNav:close', () => {
    const r = menu() && menu().querySelector('[data-egn-mm-panel="root"]')
    if (r && r.hidden) show('root')
  })
  fit()
})()
